import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	label: {
		id: 'navigation.global-shortcuts.apps.confluence',
		defaultMessage: 'Confluence',
		description: 'The link label for Confluence',
	},
});
